import { monitorSFKB } from './ar5/monitor'
import { AreaControl } from './controls/area'
import { LengthControl } from './controls/length'
import { loadBasemapSelector } from './controls/basemapSelector'
import { LegendControl } from './controls/legend'
import { LayerButtonControl } from './controls/mapLayers'
import { loadDesign } from './design'
import { getCodemap, loadAr5Combinations } from './helperFunctions'
import { removableBorders, vectorLayer } from './map/layers'
import { getLayerById, getWMS, map, setLimits, tuneOpacity } from './map/tools'
import { fillHelpText } from './navigation'
import { getLayers } from './request'
import {
  locallyAr5, setLocallyAr5,
  maxEditResolution, setGuiConfiguration,
  setMaxEditResolution, setMinDrawingZoom
} from './storage'
import { redSelectedStylePolygon } from './styles'
import { getApplicationToken, requestTicket, setToken } from './tokens'

import { load as loadYaml } from 'js-yaml'

export const decisionsBeforeLogin = () => {
  const layergroup = Number(import.meta.env.VITE_GROUP);
  console.log('layergroup', layergroup);
  const locallyAr5 = (layergroup === 2); // before login
  fillHelpText(locallyAr5);
  loadGuiConfiguration(locallyAr5);
  setToken(getApplicationToken(locallyAr5));
  if (locallyAr5) {
    setLocallyAr5(locallyAr5);
    document.body.classList.add('ar5');
    toolbar_info.style.opacity = 0.65;
    loadAr5Combinations();
    if (redSelectedStylePolygon) redSelectedStylePolygon.setFill(null);
    multi.checked = true; // MultiLineString support
  } else {
    document.getElementById('info-box-choose-layer').hidden = false;
  }
};

export const reindriftOrAr5 = (list) => {
  const isAr5 = (list.length < 1) ? locallyAr5 : (list[0].layer_name === 'AR5');
  if (isAr5 !== locallyAr5) console.log('Lagliste stemmer ikke helt.');
  updatePageTitle(isAr5);
  updateLogo(isAr5);
  getCodemap(isAr5);
  updateMapControls(isAr5);
  updateWMS(isAr5);
  if (isAr5) {
    // scale 1:2500 corresponds to resolution 0.7
    // scale 1:1250 corresponds to resolution 0.35
    setMaxEditResolution(0.65);
    setMinDrawingZoom(13.4);
    vectorLayer.setMaxResolution(maxEditResolution); // postgis layer
    removableBorders.setMaxResolution(maxEditResolution); // slå sammen
    rangePG.oninput = (e) => tuneOpacity(e.target.value);
    // setLimits('arealtypeWMS', maxEditResolution, 17); // wms for higher resolution
    setLimits('arealtypeWMS', 0, 17); // avoids empty responses for small scales
    setLimits('ar5orthoWMS', maxEditResolution, 17); // do not show it at postgis level
    setLimits('ar5_13WMS', 0, 17);
    loadARsymbolsAsFont();
    requestTicket();
    setInterval(requestTicket, 50 * 60 * 1000); // (milliseconds) new ticket every 50 min
    monitorSFKB();
  }
  document.getElementById('velgDataText').hidden = false;
  return isAr5;
};

import favicon_rein from '/favicon_rein.ico';
const changeFavicon = (name) => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = favicon_rein;
  document.getElementsByTagName('head')[0].appendChild(link);
};

const updateLogo = (ar5) => useLogo(ar5 ? 'nibio' : 'landbruksdirektoratet');

const updatePageTitle = (isAr5) => {
  let t = 'Reindrift';
  if (isAr5) t = 'AR5web'; else changeFavicon('favicon_rein');
  const hn = window.location.hostname;
  const localhost = hn.includes('localhost');
  const utv = hn.includes('utv');
  const v = (localhost || utv) ?  ' ' + __APP_VERSION__ : '';
  document.title = t + v;
};

import nibioUrl from '/img/logo/nibio.png';
import ldirUrl from '/img/logo/landbruksdirektoratet.png';
const logoUrl = { nibio: nibioUrl, landbruksdirektoratet: ldirUrl };
const useLogo = (who) => {
  const logo = document.getElementById('logo');
  const a = document.createElement('a');
  a.href = 'https://www.' + who + '.no';
  a.target = '_blank';
  logo.appendChild(a);
  const img = document.createElement('img');
  img.src = logoUrl[who];
  img.alt = who + ' logo';
  img.height = 50;
  a.appendChild(img);
};

const updateMapControls = (isAr5) => {
  const mc = map.getControls();
  let b = 137; // bottom position in pixels of the highest control button
  mc.extend([new LayerButtonControl({ position: b += 41 })]);
  if (isAr5) mc.extend([new LengthControl({ position: b += 41 })]);
  if (isAr5) mc.extend([new AreaControl({ position: b += 41 })]);
  if (isAr5) mc.extend([new LegendControl({ position: b += 41 })]);
};

const updateWMS = (isAr5) => {
  if (isAr5) {
    document.getElementById('hiddenForMinimapsWMS').hidden = true;
    document.getElementById('hiddenForMinimapsWMS_ar5').hidden = false;
    // const wms = arealtypeWMS.image['dynamicProjection'];
    // getLayerById('wmsGroup').getLayers().push(wms); // default AR5 WMS on
    // const wmsOrtho = ar5orthoWMS.image['dynamicProjection'];
    const wmsOrtho = getWMS('ar5orthoWMS');
    wmsOrtho.setVisible(false);
    // map.addLayer(wmsOrtho);
    getLayerById('wmsGroup').getLayers().push(wmsOrtho);
    // console.log(wms.getSource());
    // const graphicUrl = wms.getSource().getLegendUrl(1.1);
    // document.getElementById('legendImg').src = graphicUrl;
  } else {
    document.getElementById('hiddenForMinimapsWMS').hidden = false;
    document.getElementById('hiddenForMinimapsWMS_ar5').hidden = true;
  }
};

import ar5webConfiguration from '/config/gui/ar5web.yml?url';
import reindriftConfiguration from '/config/gui/reindrift.yml?url';
const loadGuiConfiguration = (ar5) => {
  const configurationFile = ar5 ? ar5webConfiguration : reindriftConfiguration;
  const rawFile = new XMLHttpRequest();
  rawFile.overrideMimeType('text/plain'); // default is text/xml
  rawFile.open('get', configurationFile);
  rawFile.onload = () => {
    const guiConfiguration = loadYaml(rawFile.responseText);
    setGuiConfiguration(guiConfiguration); // global variable (main.js)
    useConfiguration(guiConfiguration);
  };
  rawFile.send();
};

const useConfiguration = (guiConfig) => {
  loadDesign(guiConfig);
  loadBasemapSelector(guiConfig.backgroundLayers);
  // Start process by getting layers from server
  getLayers();
};

import ttfUrl from '/fonts/ARsymboler.ttf';
const loadARsymbolsAsFont = () => {
  document.fonts.add(new FontFace('ARsymbols', `url(${ttfUrl})`));
};
